// Device geolocation: requests permission and tracks the last known fix.
// We never block the UI on GPS — the banner reflects whether permission was granted
// and the last fix is sent opportunistically with each event.

import { state } from '../state.js';

let watchId = null;

export function requestGeolocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      state.gpsGranted = false;
      state.gpsDenied = true;
      return resolve(null);
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        state.gpsGranted = true;
        state.gpsDenied = false;
        state.lastGps = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        startWatch();
        resolve(state.lastGps);
      },
      (_err) => {
        state.gpsGranted = false;
        state.gpsDenied = true;
        state.lastGps = null;
        resolve(null);
      },
      { enableHighAccuracy: false, maximumAge: 60_000, timeout: 10_000 }
    );
  });
}

function startWatch() {
  if (watchId != null) return;
  try {
    watchId = navigator.geolocation.watchPosition(
      (pos) => {
        state.lastGps = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      },
      () => { /* keep last good fix */ },
      { enableHighAccuracy: false, maximumAge: 30_000 }
    );
  } catch { /* ignore */ }
}
